// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import UnitedKingdom from '../_raw/flag/icon_flag_united_kingdom.png';

export default () => <img src={UnitedKingdom} alt="UnitedKingdom" />;
